import {ssrSafeWindow} from '@github-ui/ssr-utils'

const nonce = ssrSafeWindow?.document?.head?.querySelector<HTMLMetaElement>('meta[name="fetch-nonce"]')?.content || ''

export default function getFetchNonce() {
  return nonce
}
